import { render, staticRenderFns } from "./AssignAgentDialog.vue?vue&type=template&id=af728f44&"
import script from "./AssignAgentDialog.vue?vue&type=script&lang=js&"
export * from "./AssignAgentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports